import { createStore } from "vuex";

import auth from "./modules/auth";
import common from "./modules/common";
import stores from "./modules/common/stores";
import menus from "./modules/common/menus";
import options from "./modules/common/options";
import vendors from "./modules/common/vendors";
import invoices from "./modules/common/invoices";
import coupons from "./modules/common/coupons";
import users from "./modules/common/users";
import products from "./modules/common/products";
import customerscreens from "./modules/common/branchsetting/customerscreens";
import menuboards from "./modules/common/branchsetting/menuboards";
import stocks from "./modules/common/stock/stocks";
import reports from "./modules/common/stock/rerports";
import audits from "./modules/common/stock/audits";
import hours from "./modules/common/branchsetting/hours";
import sms from "./modules/common/sms";
import deals from "./modules/common/deals";
import rbac from "./modules/common/rbac";
import featured from "./modules/common/featured";
import liveorders from "./modules/common/liveorders";
import grouporders from "./modules/common/grouporders";
import loyalty from "./modules/common/loyalty";
import appai from "./modules/common/appai";
import creations from "./modules/common/creations";
import panel from "./modules/common/panel";
import chat from "./modules/common/chat";
import approvals from "./modules/common/approvals";
import assistant from "./modules/common/assistant";

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  getters: {},
  modules: {
    rbac,
    featured,
    liveorders,
    grouporders,
    loyalty,
    appai,
    creations,
    panel,
    chat,
    approvals,
    assistant,
    auth,
    common,
    stores,
    menus,
    options,
    stocks,
    vendors,
    invoices,
    coupons,
    users,
    products,
    customerscreens,
    menuboards,
    reports,
    audits,
    hours,
    sms,
    deals,
  },
});
